// Where ads must never appear: payment, sign-in, account, API-key and admin pages, plus the token-link apps.
// Used by the manual ad units (AdBanner.tsx), by the ad-script loader (consent.ts) and by the page-level switch
// that hides Google's automatic ads after in-app navigation to one of these pages.
//
// Locale prefixes ("/de/profile") are ignored when matching.

import { parseLocaleFromPath } from "@/lib/i18n/locales";

const EXCLUDED_PREFIXES = [
  "/checkout",
  "/login",
  "/pricing",
  "/profile",
  "/account",
  "/organization",
  "/admin",
  "/developers", // API keys are created and shown here
  "/apps/", // door / booth / guest token links
];

export function adsExcludedPath(pathname: string): boolean {
  const path = (parseLocaleFromPath(pathname).rest || "/").toLowerCase();
  return EXCLUDED_PREFIXES.some((p) => (p.endsWith("/") ? path.startsWith(p) : path === p || path.startsWith(`${p}/`)));
}

export const NO_ADS_ATTR = "data-no-ads";

/** Marks the page so index.css hides any automatic ad Google may already have placed. */
export function applyNoAdsFlag(pathname: string) {
  if (typeof document === "undefined") return;
  if (adsExcludedPath(pathname)) document.documentElement.setAttribute(NO_ADS_ATTR, "");
  else document.documentElement.removeAttribute(NO_ADS_ATTR);
}

/**
 * Classes that keep Google's automatic ads (and its in-text "Try ..." annotation chips) out of an area. Put on the tool
 * itself and its subtitle, so automatic ads appear only in the content sections below the tool. Ads are never removed
 * from the page: the anchor, the reserved units below the result and the lower unit all stay.
 */
export const AUTO_ADS_EXCLUDE_CLASS = "google-auto-ads-ignore google-anno-skip";
